import customAxios from '../../customAxios';
import { ACADEMIC_YEAR } from '../../routes';
import { IAcademicYearForm } from '../../../types/academicYear.interface';

async function updateAcademicYear(_id: string, props: IAcademicYearForm) {
  try {
    return (await customAxios.patch(`${ACADEMIC_YEAR}/${_id}`, props)).data;
  } catch (error: any) {
    console.error({ ACADEMIC_YEAR: error });
  }
}

export default updateAcademicYear;
